export const COMMENTS_PAGE_SIZE = 4;
export const FETCH_NEXT_PDP_COMMENTS_INDEX = 1;